<template>
    <div v-if="isTooltipShow" class="tooltip-wrap" :class="additionalClass">
        <div class="tooltip-pop create-course-box" :class="additionalBoxClass">
            <p v-if="dataTooltipInfo.title" class="tooltip-pop__title">
                {{ dataTooltipInfo.title }}
            </p>
            <p v-if="dataTooltipInfo.text" class="tooltip-pop__text">{{ dataTooltipInfo.text }}</p>
            <router-link
                v-if="parent === 'recipients'"
                :to="dataTooltipInfo.link.url"
                class="tooltip-pop__text text_orange"
                style="display: block"
            >
                {{ dataTooltipInfo.link.title }}
            </router-link>

            <p v-if="dataTooltipInfo.subtitle" class="tooltip-pop__subtitle">
                {{ dataTooltipInfo.subtitle }}
            </p>
            <ul
                v-if="dataTooltipInfo.list && dataTooltipInfo.list.length"
                class="tooltip-pop__list"
                :class="additionalListClass"
            >
                <li v-for="(item, index) in dataTooltipInfo.list" :key="index">
                    {{ item }}
                </li>
            </ul>
            <button @click="closeTooltip" class="tooltip-pop__btn btn2 btn2_clear" type="button">
                {{ t("expert.close") }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["dataTooltip", "additionalListClass", "additionalBoxClass", "parent", "additionalClass"],
    data() {
        return {
            isTooltipShow: false,
            dataTooltipInfo: this.dataTooltip
        }
    },
    methods: {
        showTooltip() {
            this.isTooltipShow = true
        },
        closeTooltip() {
            this.$emit("closeTooltip")
            this.isTooltipShow = false
        }
    }
}
</script>
